import script from "./BookingSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingSummary.vue?vue&type=script&setup=true&lang=ts"

import "./BookingSummary.vue?vue&type=style&index=0&id=8070136a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8070136a"]])

export default __exports__